import { useAuth } from '$features/auth/hooks/use-auth'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { LinkButton, Text } from '$components'
import { ClockIcon, LinkIcon } from '$components'
import { Config } from '$config/app'

export function SubscriptionExpiryBanner() {
  const { hasSubscriptionExpired } = useTenant()
  const { user } = useAuth()

  if (!hasSubscriptionExpired) {
    return null
  }

  return (
    <div className="w-full bg-indigo-500 p-2.5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
      <div className="flex items-start gap-3">
        <ClockIcon className="min-w-5 min-h-5 size-5 text-white mt-1" />
        <div className="flex-1">
          <Text className="text-sm text-white">
            Your subscription has expired
          </Text>
          <Text className="text-sm text-gray-100 font-light leading-relaxed">
            You can still access all of your data, but will not be able to create new records or update existing ones. Upgrade to continue using Tailly.
          </Text>
        </div>
      </div>

      <LinkButton
        to={Config.getStripeBillingUrl(user!.email)}
        variant="secondary"
        className="border-transparent w-full sm:w-auto sm:ml-4"
        icon={LinkIcon}
      >
        Upgrade your plan
      </LinkButton>
    </div>
  )
}
